/**
 * Custom JavaScript for handling product variant selection, cart drawer, and Ajax infinite scroll.
 * Ensures variant selection works for both initial and dynamically loaded products.
 */

document.addEventListener("DOMContentLoaded", function () {
    function refreshMiniCart() {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        toggleCartDrawer(true);
    }

    function toggleCartDrawer(isOpen) {
        let cartDrawer = document.getElementById("sidebar-cart");
        let pageOverlay = document.querySelector(".PageOverlay");
        if (cartDrawer && pageOverlay) {
            cartDrawer.setAttribute("aria-hidden", isOpen ? "false" : "true");
            cartDrawer.classList.toggle("is-visible", isOpen);
            pageOverlay.classList.toggle("is-visible", isOpen);
        }
    }

    document.addEventListener("change", function (event) {
        if (event.target.matches(".variant-selector")) {
            let form = event.target.closest(".product-item-form");
            if (form) {
                let formData = {
                    items: [
                        {
                            id: event.target.value,
                            quantity: 1
                        }
                    ]
                };
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    if (response.ok) {
                        refreshMiniCart();
                    }
                })
                .catch(error => {});
            }
        }
    });

    document.addEventListener("click", function (event) {
        if (event.target.matches("[data-action='close-drawer'], .PageOverlay")) {
            toggleCartDrawer(false);
        }
    });

    let cartDrawer = document.getElementById("sidebar-cart");
    if (cartDrawer) {
        cartDrawer.addEventListener("click", function (event) {
            event.stopPropagation();
        });
    }

    if (typeof Ajaxinate === "function") {
        let container = document.querySelector("#AjaxinateContainer");
        let pagination = document.querySelector("#AjaxinatePagination");
        if (container && pagination) {
            let loadMoreLink = pagination.querySelector(".Pagination__Next");
            if (loadMoreLink) {
                try {
                    new Ajaxinate({
                        container: "#AjaxinateContainer",
                        pagination: "#AjaxinatePagination",
                        method: "scroll",
                        callback: function () {
                            ensureVisibility();
                        }
                    });
                } catch (error) {}
            }
        }
    }
});

function ensureVisibility() {
    document.querySelectorAll("#AjaxinateContainer .Grid__Cell").forEach(el => {
        el.style.opacity = "1";
        el.style.visibility = "visible";
        el.style.transform = "none";
    });

    let newPagination = document.querySelector("#AjaxinatePagination");
    if (!newPagination || !newPagination.innerHTML.trim()) {
        newPagination?.remove();
    }
}

document.addEventListener("DOMContentLoaded", function () {
    function updateCartCount() {
        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                if (!cart || typeof cart.item_count === "undefined") {
                    return;
                }

                let headerCartCount = document.querySelector(".Drawer__Title .cart-count");
                if (headerCartCount) {
                    headerCartCount.innerHTML = cart.item_count;
                }
            })
            .catch(error => {});
    }

    function observeCartDrawerChanges() {
        let cartDrawer = document.querySelector("#sidebar-cart");

        if (!cartDrawer) {
            return;
        }

        const observer = new MutationObserver(() => {
            updateCartCount();
        });

        observer.observe(cartDrawer, { childList: true, subtree: true });
    }

    document.documentElement.addEventListener("cart:refresh", function () {
        setTimeout(updateCartCount, 100);
    });

    document.addEventListener("click", function (event) {
        if (event.target.matches("[data-action='open-cart']")) {
            event.preventDefault();
            openCartDrawer();
        }
    });

    observeCartDrawerChanges();
    updateCartCount();
});

document.addEventListener("DOMContentLoaded", function () {
    function openCartDrawer() {
        let cartDrawer = document.getElementById("sidebar-cart");
        let pageOverlay = document.querySelector(".PageOverlay");

        if (cartDrawer) {
            cartDrawer.setAttribute("aria-hidden", "false");
            cartDrawer.classList.add("is-visible");
        }

        if (pageOverlay) {
            pageOverlay.classList.add("is-visible");
        }

        document.body.classList.add("cart-open");
    }

    function closeCartDrawer() {
        let cartDrawer = document.getElementById("sidebar-cart");
        let pageOverlay = document.querySelector(".PageOverlay");

        if (cartDrawer) {
            cartDrawer.setAttribute("aria-hidden", "true");
            cartDrawer.classList.remove("is-visible");
        }

        if (pageOverlay) {
            pageOverlay.classList.remove("is-visible");
        }

        document.body.classList.remove("cart-open");
    }

    document.addEventListener("click", function (event) {
        let cartButton = event.target.closest("[data-action='open-cart']");
        let navButton = event.target.closest("[data-action='open-menu']");

        if (cartButton) {
            event.preventDefault();
            openCartDrawer();
        }

        if (navButton) {
            event.preventDefault();
            openMobileMenu();
        }
    });

    document.querySelectorAll("[data-action='close-drawer']").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            closeCartDrawer();
        });
    });

    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("PageOverlay")) {
            closeCartDrawer();
        }
    });

    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            closeCartDrawer();
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    function openMobileMenu() {
        let navMenu = document.getElementById("mobile-nav");
        let pageOverlay = document.querySelector(".PageOverlay");

        if (navMenu) {
            navMenu.classList.add("is-visible");
        }

        if (pageOverlay) {
            pageOverlay.classList.add("is-visible");
        }

        document.body.classList.add("menu-open");
    }

    function closeMobileMenu() {
        let navMenu = document.getElementById("mobile-nav");
        let pageOverlay = document.querySelector(".PageOverlay");

        if (navMenu) {
            navMenu.classList.remove("is-visible");
        }

        if (pageOverlay) {
            pageOverlay.classList.remove("is-visible");
        }

        document.body.classList.remove("menu-open");
    }

    document.addEventListener("click", function (event) {
        if (event.target.matches("[data-action='open-menu']")) {
            event.preventDefault();
            openMobileMenu();
        }
    });

    document.querySelectorAll("[data-action='close-menu']").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            closeMobileMenu();
        });
    });

    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("PageOverlay")) {
            closeMobileMenu();
        }
    });

    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            closeMobileMenu();
        }
    });
});


//----- MOBILE HOVER

// Mobile Hover Images
document.addEventListener("DOMContentLoaded", function () {
    let pressTimer;
    let touchStartY = 0;
    let touchMoved = false;

    function isMobileScreen() {
        return window.innerWidth <= 1140;
    }

    function applyHoverEffectToProducts(products) {
        products.forEach((item) => {
            let firstImage = item.querySelector(".ProductItem__Image");
            let alternateImage = item.querySelector(".ProductItem__Image--alternate");

            if (!firstImage || !alternateImage) return;

            // Ensure alternate image is preloaded & positioned correctly
            alternateImage.style.opacity = "0";
            alternateImage.style.display = "block"; 
            alternateImage.style.position = "absolute";
            alternateImage.style.top = "0";
            alternateImage.style.left = "0";
            alternateImage.style.width = "100%";
            alternateImage.style.height = "100%";
            alternateImage.style.zIndex = "1"; 

            // Touchstart: Detect long press
            item.addEventListener("touchstart", function (e) {
                if (!isMobileScreen()) return;

                touchMoved = false;
                touchStartY = e.touches[0].clientY;

                pressTimer = setTimeout(() => {
                    if (!touchMoved) {
                        firstImage.style.transition = "opacity 0.2s ease-in-out";
                        firstImage.style.opacity = "0";

                        alternateImage.style.transition = "opacity 0.2s ease-in-out";
                        alternateImage.style.setProperty("opacity", "1", "important");
                        alternateImage.style.setProperty("display", "block", "important");
                    }
                }, 300);
            });

            // Touchmove: Detect scrolling
            item.addEventListener("touchmove", function (e) {
                let moveY = e.touches[0].clientY;
                if (Math.abs(moveY - touchStartY) > 100) {
                    touchMoved = true;
                    clearTimeout(pressTimer);
                }
            });

            // Touchend: Restore images if no scrolling
            item.addEventListener("touchend", function () {
                clearTimeout(pressTimer);
                if (!touchMoved) {
                    firstImage.style.opacity = "1";
                    alternateImage.style.opacity = "0";
                }
            });
        });
    }

    // Apply hover effect to initial products and expose globally
    applyHoverEffectToProducts(document.querySelectorAll(".ProductItem"));
    window.applyHoverEffectToProducts = applyHoverEffectToProducts;

    // Detect when new products are added via infinite scroll (Mobile Hover)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) {
                    if (node.classList.contains("ProductItem")) {
                        applyHoverEffectToProducts([node]);
                    } else {
                        let newProducts = node.querySelectorAll?.(".ProductItem");
                        if (newProducts && newProducts.length) {
                            applyHoverEffectToProducts(newProducts);
                        }
                    }
                }
            });
        });
    });

    const productContainer = document.querySelector("#AjaxinateContainer");
    if (productContainer) {
        observer.observe(productContainer, { childList: true, subtree: true });
    }

    // Tapping outside resets images
    document.addEventListener("touchstart", function (e) {
        if (!isMobileScreen()) return;
        if (!e.target.closest(".ProductItem")) {
            document.querySelectorAll(".ProductItem").forEach((item) => {
                let firstImage = item.querySelector(".ProductItem__Image");
                let alternateImage = item.querySelector(".ProductItem__Image--alternate");
                if (firstImage) firstImage.style.opacity = "1";
                if (alternateImage) alternateImage.style.opacity = "0";
            });
        }
    });
});


// Product Overlay
document.addEventListener('searchspring.domReady', function() {
  function isSmallScreen() {
    return window.innerWidth <= 1139;
  }

  function openOverlay(event) {
    event.stopPropagation();
    event.preventDefault();

    let productId = this.getAttribute('data-product-id');
    let overlayWrapper = document.getElementById(`product-overlay-wrapper-${productId}`);
    let overlay = document.getElementById(`product-overlay-${productId}`);
    let messageElement = overlay ? overlay.querySelector('.ProductOverlayMessage') : null;

    if (overlayWrapper && overlay) {
      overlayWrapper.classList.add('active');
      overlay.classList.add('active');

      // Disable background scrolling on mobile
      if (isSmallScreen()) {
        document.body.classList.add('no-scroll');
      }
      // Clear any existing stock message
      if (messageElement) {
        messageElement.innerHTML = "";
      }
    } else {
      console.error("Overlay wrapper or overlay not found for Product ID:", productId);
    }
  }

  function closeOverlay(productId) {
    let overlayWrapper = document.getElementById(`product-overlay-wrapper-${productId}`);
    let overlay = document.getElementById(`product-overlay-${productId}`);
    if (overlayWrapper && overlay) {
      overlayWrapper.classList.remove('active');
      overlay.classList.remove('active');
      if (isSmallScreen()) {
        document.body.classList.remove('no-scroll');
      }
    }
  }

  function closeOverlayOnMouseLeave(event) {
    let productId = this.getAttribute('data-product-id');
    let overlayWrapper = document.getElementById(`product-overlay-wrapper-${productId}`);
    let overlay = document.getElementById(`product-overlay-${productId}`);

    if (event.relatedTarget && (overlay.contains(event.relatedTarget) || overlayWrapper.contains(event.relatedTarget))) {
      return;
    }

    if (!isSmallScreen() && overlayWrapper && overlay) {
      closeOverlay(productId);
    }
  }

  function handleCloseClick(event) {
    event.stopPropagation();
    event.preventDefault();
    let productId = this.getAttribute('onclick').match(/\d+/)[0];
    closeOverlay(productId);
  }

  function handleVariantHover(event) {
    updateStockMessage(this);
  }

  function handleVariantClick(event) {
    event.stopPropagation();
    event.preventDefault();

    let variantId = this.getAttribute('data-variant-id');
    let inventoryCount = parseInt(this.getAttribute('data-inventory'), 10);
    let productId = this.closest('.ProductOverlayWrapper').getAttribute('data-product-id');

    // For non-sold-out variants, add to cart
    if (inventoryCount === 0) {
      return;
    }

    let formData = {
      items: [{ id: variantId, quantity: 1 }]
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      openCartDrawer();
      if (isSmallScreen()) {
        setTimeout(() => {
          closeOverlay(productId);
        }, 300);
      }
    })
    .catch(error => {
      console.error("Error adding to cart:", error);
    });
  }

  function openCartDrawer() {
    let cartDrawer = document.getElementById("sidebar-cart");
    let pageOverlay = document.querySelector(".PageOverlay");

    if (cartDrawer) {
      cartDrawer.setAttribute("aria-hidden", "false");
      cartDrawer.classList.add("is-visible");
    }
    if (pageOverlay) {
      pageOverlay.classList.add("is-visible");
    }
    document.body.classList.add("cart-open");
  }

  function addEventListeners() {
    // Bind overlay open/close events
    document.querySelectorAll('.open-overlay').forEach(button => {
      if (!isSmallScreen()) {
        button.removeEventListener('mouseenter', openOverlay);
        button.removeEventListener('mouseleave', closeOverlayOnMouseLeave);
        button.addEventListener('mouseenter', openOverlay);
        button.addEventListener('mouseleave', closeOverlayOnMouseLeave);
      }
    });

    document.querySelectorAll('.open-overlay_mobile').forEach(button => {
      if (isSmallScreen()) {
        button.removeEventListener('click', openOverlay);
        button.addEventListener('click', openOverlay);
      }
    });

    // Ensure close button works for mobile
    document.querySelectorAll('.ProductOverlay__Close').forEach(button => {
      button.removeEventListener('touchstart', handleCloseClick);
      button.addEventListener('touchstart', handleCloseClick);
    });

    // Bind variant hover for all variant labels
    document.querySelectorAll('.variant-selector-btn_product').forEach(label => {
      label.removeEventListener('mouseenter', handleVariantHover);
      label.addEventListener('mouseenter', handleVariantHover);
    });
    // For non-sold-out variants, bind click normally
    document.querySelectorAll('.variant-selector-btn_product:not(.soldout)').forEach(label => {
      if (isSmallScreen()) {
        label.removeEventListener('touchstart', handleVariantClick);
        label.addEventListener('touchstart', handleVariantClick);
      } else {
        label.removeEventListener('click', handleVariantClick);
        label.addEventListener('click', handleVariantClick);
      }
    });
    // For sold-out variants on mobile, bind click to open the restock modal every time
    if (isSmallScreen()) {
      document.querySelectorAll('.variant-selector-btn_product.soldout').forEach(label => {
          label.removeEventListener('touchstart', handleVariantClick);
          label.addEventListener('touchstart', function(event) {
             event.stopPropagation();
             event.preventDefault();
             let variantId = this.getAttribute('data-variant-id');
             let productData = this.getAttribute('data-product');
             if (!variantId || !productData) {
                 console.error("Missing product data or variant id.");
                 return;
             }
             try {
                 productData = JSON.parse(productData);
             } catch(e) {
                 console.error("Error parsing product data", e);
                 return;
             }
             if (window._RestockRocket) {
                 // Force-close the modal first, if the API supports it
                 if (typeof window._RestockRocket.closeModal === "function") {
                     window._RestockRocket.closeModal();
                 }
                 // Then open the restock modal
                 window._RestockRocket.openModal(productData, variantId);
             } else {
                 console.error("Stoq API (RestockRocket) is not loaded.");
             }
         });
      });
    }
  }

  // Expose overlay event binding globally so it can be re‑applied to Ajaxinate-loaded products
  window.addProductOverlayEventListeners = addEventListeners;

  addEventListeners();
  window.addEventListener('resize', addEventListeners);
});
/**/

// ProductList Transform Reset
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.ProductList').forEach(el => {
    el.style.transform = "none";
  });

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.target.style.transform.includes("matrix(1, 0, 0, 1, 0, 0)")) {
        mutation.target.style.transform = "none";
      }
    });
  });

  document.querySelectorAll('.ProductList').forEach(el => {
    observer.observe(el, { attributes: true, attributeFilter: ["style"] });
  });
});


// Stock Message and Restock Functionality
function updateStockMessage(element) {
    let overlay = element.closest('.ProductOverlay');
    if (!overlay) {
        console.error("Product overlay not found.");
        return;
    }
    let messageElement = overlay.querySelector('.ProductOverlayMessage');
    if (!messageElement) {
        console.error("Stock message element not found.");
        return;
    }
    let variantElements = overlay.querySelectorAll("[data-inventory]");
    if (!variantElements.length) {
        console.error("No variant elements found.");
        return;
    }
    let allVariantsSoldOut = true;
    let defaultProductData = null;
    let defaultVariantId = null;

    variantElements.forEach(variant => {
        let variantInventory = parseInt(variant.getAttribute('data-inventory'), 10);
        if (variantInventory > 0) {
            allVariantsSoldOut = false;
        }
        if (!defaultProductData || !defaultVariantId) {
            defaultProductData = variant.getAttribute('data-product');
            defaultVariantId = variant.getAttribute('data-variant-id');
        }
    });

    if (allVariantsSoldOut) {
        if (!defaultProductData || !defaultVariantId) {
            console.error("Missing product data or variant ID for fully sold-out product.");
            return;
        }
        defaultProductData = JSON.parse(defaultProductData);
        messageElement.innerHTML = `
            <span id="RestockCollectionView" style="cursor:pointer;">
                Out Of Stock. <span style="text-decoration:underline;">Notify me when available.</span>
            </span>`;
        attachRestockListener(messageElement, defaultProductData, defaultVariantId);
        return;
    }

    // Attach a mouseenter event on each variant that clears and then sets the message
    variantElements.forEach(variant => {
        variant.addEventListener("mouseenter", function () {
            // Always clear any previous message
            messageElement.innerHTML = "";
            let hoveredInventory = parseInt(variant.getAttribute('data-inventory'), 10);
            let hoveredProductData = variant.getAttribute('data-product');
            let hoveredVariantId = variant.getAttribute('data-variant-id');

            if (!hoveredProductData || !hoveredVariantId) {
                console.error("Missing product data or variant ID on hover.");
                return;
            }
            hoveredProductData = JSON.parse(hoveredProductData);

            if (hoveredInventory === 0) {
                messageElement.innerHTML = `<span id="RestockCollectionView" style="cursor:pointer;">Out Of Stock. <span style="text-decoration:underline;">Notify me when available.</span></span>`;
                attachRestockListener(messageElement, hoveredProductData, hoveredVariantId);
            } else if (hoveredInventory < 5) {
                messageElement.innerHTML = "Low Stock";
            } else {
                messageElement.innerHTML = "";
            }
        });
    });

    let initiallySelectedVariant = overlay.querySelector(".variant-selector-btn_product.selected");
    if (initiallySelectedVariant) {
        let initialInventory = parseInt(initiallySelectedVariant.getAttribute('data-inventory'), 10);
        let initialProductData = initiallySelectedVariant.getAttribute('data-product');
        let initialVariantId = initiallySelectedVariant.getAttribute('data-variant-id');

        if (initialInventory === 0) {
            messageElement.innerHTML = `<span id="RestockCollectionView" style="cursor:pointer;">Out Of Stock. <span style="text-decoration:underline;">Notify me when available.</span></span>`;
            attachRestockListener(messageElement, JSON.parse(initialProductData), initialVariantId);
        } else if (initialInventory < 5) {
            messageElement.innerHTML = "Low Stock";
        } else {
            messageElement.innerHTML = "";
        }
    }
}

function attachRestockListener(messageElement, productData, variantId) {
    let notifyButton = messageElement.querySelector('#RestockCollectionView');
    if (!notifyButton) return;
    let clonedButton = notifyButton.cloneNode(true);
    notifyButton.parentNode.replaceChild(clonedButton, notifyButton);
    clonedButton.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();
        if (window._RestockRocket) {
            window._RestockRocket.openModal(productData, variantId);
        } else {
            console.error("Stoq API (RestockRocket) is not loaded.");
        }
    });
}

function attachRestockListeners() {
    document.querySelectorAll("#RestockCollectionViewMobile").forEach(button => {
        button.addEventListener("click", function(event) {
            event.stopPropagation();
            event.preventDefault();

            let parentElement = button.closest(".ProductOverlay");
            if (!parentElement) return;
            let variantElement = parentElement.querySelector("[data-inventory]");
            if (!variantElement) {
                console.error("Variant data element not found.");
                return;
            }
            let productData = variantElement.getAttribute("data-product");
            let variantId = variantElement.getAttribute("data-variant-id");
            if (!productData || !variantId) {
                console.error("Missing product data or variant ID.");
                return;
            }
            productData = JSON.parse(productData);
            if (window._RestockRocket) {
                window._RestockRocket.openModal(productData, variantId);
            } else {
                console.error("Stoq API (RestockRocket) is not loaded.");
            }
        });
    });
}

// Initialize stock messages and restock listeners on page load
window.addEventListener("searchspring.domReady", function () {
    document.querySelectorAll("[data-inventory]").forEach(element => {
        updateStockMessage(element);
    });
    attachRestockListeners();
});

// Ajaxinate Callback for Infinite Scroll
if (typeof Ajaxinate === "function") {
    new Ajaxinate({
        container: "#AjaxinateContainer",
        pagination: "#AjaxinatePagination",
        method: "scroll",
        callback: function () {
            document.querySelectorAll("[data-inventory]").forEach(element => {
                updateStockMessage(element);
            });
            // Re-bind overlay event listeners for new products
            if (typeof window.addProductOverlayEventListeners === "function") {
              window.addProductOverlayEventListeners();
            }
        }
    });
}

// Additional MutationObserver for newly added products (if needed)
const infiniteScrollObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
                let newProducts = [];
                if (node.classList.contains("ProductItem")) {
                    newProducts.push(node);
                } else {
                    newProducts = node.querySelectorAll?.(".ProductItem");
                }
                if (newProducts && newProducts.length) {
                    window.applyHoverEffectToProducts(newProducts);
                    if (typeof window.addProductOverlayEventListeners === "function") {
                        window.addProductOverlayEventListeners();
                    }
                }
            }
        });
    });
});
const ajaxContainer = document.querySelector("#AjaxinateContainer");
if (ajaxContainer) {
    infiniteScrollObserver.observe(ajaxContainer, { childList: true, subtree: true });
}

// Product Video

document.addEventListener('DOMContentLoaded', function () {
  const slideshow = document.querySelector('.Product__Slideshow');

  if (!slideshow) return;

  const forceAutoplay = (video) => {
    if (!video) return;

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('loop', '');
    video.muted = true;
    video.autoplay = true;
    video.playsInline = true;
    video.loop = true;
    video.removeAttribute('poster');

    video.play().catch((err) => {
      console.warn('Autoplay blocked, waiting for interaction', err);
      const unlock = () => {
        video.play().catch(() => {});
        document.removeEventListener('click', unlock);
        document.removeEventListener('scroll', unlock);
      };
      document.addEventListener('click', unlock);
      document.addEventListener('scroll', unlock);
    });
  };

  const playActiveVideo = () => {
    document.querySelectorAll('.Product__SlideItem video').forEach(video => {
      video.pause();
      video.currentTime = 0;
    });

    const activeSlide = slideshow.querySelector('.Product__SlideItem.is-selected');
    if (activeSlide) {
      const video = activeSlide.querySelector('video');
      forceAutoplay(video);
    }
  };

  // Flickity support
  if (typeof Flickity !== 'undefined') {
    const flkty = Flickity.data(slideshow);
    if (flkty) {
      flkty.on('select', playActiveVideo);
      flkty.on('ready', () => setTimeout(playActiveVideo, 100));
    } else {
      setTimeout(playActiveVideo, 300);
    }
  } else {
    setTimeout(playActiveVideo, 300);
  }

  // Play video when user clicks the thumbnail nav
  document.querySelectorAll('.Product__SlideshowNavImage[data-media-id]').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mediaId = this.getAttribute('data-media-id');
      if (!mediaId) return;

      setTimeout(() => {
        const targetSlide = document.querySelector(`#Media${mediaId}`);
        if (targetSlide) {
          const video = targetSlide.querySelector('video');
          forceAutoplay(video);
        }
      }, 400); 
    });
  });

  // Autoplay video when it scrolls into view (desktop only)
  if (window.innerWidth >= 1024) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target.querySelector('video');
          if (video && video.paused) {
            forceAutoplay(video);
          }
        }
      });
    }, {
      threshold: 0.75 // Trigger when 75% visible
    });

    document.querySelectorAll('.Product__SlideItem--video').forEach(slide => {
      observer.observe(slide);
    });
  }
});

